<template>
    <div>
        <events-chart
        ></events-chart>

        <events-distribution class="mt-4"
        ></events-distribution>

        <events-products class="mt-4"
        ></events-products>
    </div>
</template>

<script>

    import EventsChart from '@/components/statistic/EventsChart'
    import EventsDistribution from '@/components/statistic/EventsDistribution'
    import EventsProducts from '@/components/statistic/EventsProducts'

    export default {
        name: 'statistics',
        components: {
            EventsChart,
            EventsProducts,
            EventsDistribution,
        }
    }
</script>

<style>

</style>
